// extracted by mini-css-extract-plugin
module.exports = {"container":"appointments__AppointmentAvailability__container"};